import { Component, ElementRef, ViewChild } from '@angular/core';
import { WaterFallLoadMoreEvent } from '../common/components/water.fall.container/water.fall.container.component';

@Component({
    template: `
        <ig-water-fall-container #waterfall [itemWidth]="300" [isAllItemsLoaded]="isAllDataLoaded"
                                 (onLoadMore)="loadMore($event)">
            <div *ngFor="let item of items" [ngStyle]="item.styles">
                {{item.value}}
            </div>
        </ig-water-fall-container>
    `
})
export class FallComponent {
    @ViewChild('waterfall', {read: ElementRef}) public waterFall: ElementRef;

    private _itemCounts = 0;
    public items = [];
    public isAllDataLoaded: boolean;

    constructor() {
    }

    public ngAfterViewInit() {
        this.loadMore();
    }

    public loadMore(event: WaterFallLoadMoreEvent = null) {
        for (let i = 0; i < 20; i++) {
            let background = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
            this.items.push({
                styles: {
                    color: 'red',
                    fontSize: '60px',
                    background: `${background}`,
                    height: `${Math.floor(Math.random() * 50) + 300}px`
                },
                value: this._itemCounts + i
            });
        }
        this._itemCounts += 20;

        if (!!event) {
            event.loadMore();
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/fall.component.ts